"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var CellUnits = {
    Day: 0,
    Hour: 1
};

exports.default = CellUnits;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-big-scheduler/lib/CellUnits.js
// module id = 2067
// module chunks = 0